import {
    ResultObj,
    allFetch,
} from "../Domain";

/**交修項目新建 (參數)
 * @description 交修項目新建 (參數)
 * @param {string} trs_code 交修項目代號
 * @param {string} trs_name 交修項目名稱
 * @param {string} note 備註
 */
export interface TurnoverRepairCreateParams {
    trs_code?: string;
    trs_name: string;
    note?: string;
}

/** @description 交修項目新建 */
export const TurnoverRepairCreate = async function (
    obj: TurnoverRepairCreateParams
): Promise<ResultObj> {
    return await allFetch('TurnoverRepair/TurnoverRepairCreate', obj);
};

/**交修項目修改 (參數)
 * @description 交修項目修改 (參數)
 * @param {string} trs_id 交修項目流水號
 * @param {string} trs_code 交修項目代號
 * @param {string} trs_name 交修項目名稱
 * @param {string} note 備註
 * @param {string} visible 是否可見
 */
export interface TurnoverRepairUpdateParams {
    trs_id: string;
    trs_code?: string;
    trs_name: string;
    note?: string;
    visible: string;
}

/** @description 交修項目修改 */
export const TurnoverRepairUpdate = async function (
    obj: TurnoverRepairUpdateParams
): Promise<ResultObj> {
    return await allFetch('TurnoverRepair/TurnoverRepairUpdate', obj);
};

/**交修項目查詢 (參數)
 * @description 交修項目查詢 (參數)
 * @param {string} trs_id 交修項目流水號
 * @param {string} trs_code 交修項目代號
 * @param {string} trs_name 交修項目名稱
 * @param {string} note 備註
 * @param {string} visible 是否可見
 */
export interface TurnoverRepairSearchParams {
    trs_id?: string;
    trs_code?: string;
    trs_name?: string;
    visible?: string;
    page:number;
    num_per_page:number
}

/**@descreiption 交修項目查詢 (回傳) */
export interface TurnoverRepairSearchResItem {
    note: string;
    trs_code: string;
    trs_id: string;
    trs_name: string;
    visible: string;
}

/** @description 交修項目查詢 */
export const TurnoverRepairSearch = async function (
    obj: TurnoverRepairSearchParams
): Promise<ResultObj<TurnoverRepairSearchResItem[]>> {
    return await allFetch('TurnoverRepair/TurnoverRepairSearch', obj);
};


/**交修項目細項 (參數)
 * @description 交修項目細項 (參數)
 * @param {string} trs_id 交修項目流水號
 */
export interface TurnoverRepairDetailParams {
    trs_id: string;  
}

/**@descreiption 交修項目細項 (回傳) */
export interface TurnoverRepairDetailResItem {
    note: string;
    trs_code: string;
    trs_id: string;
    trs_name: string;
    visible: string;
}

/** @description 交修項目細項 */
export const TurnoverRepairDetail = async function (
    obj: TurnoverRepairDetailParams
): Promise<ResultObj<TurnoverRepairDetailResItem[]>> {
    return await allFetch('TurnoverRepair/TurnoverRepairDetail', obj);
};

/**交修項目刪除 (參數)
 * @description 交修項目刪除 (參數)
 * @param {string} trs_id 交修項目流水號
 */
export interface TurnoverRepairDeleteParams {
    trs_id: string;  
}

/** @description 交修項目刪除 */
export const TurnoverRepairDelete = async function (
    obj: TurnoverRepairDeleteParams
): Promise<ResultObj> {
    return await allFetch('TurnoverRepair/TurnoverRepairDelete', obj);
};